import React, { useContext } from "react";
import styled from "styled-components";
import ToolbarSnacksContainer from "containers/chrome/toolbar_snacks_container";

import { GlobalContext } from "helpers/react_context/global_context";

const StyledContentToolbar = styled.div`
  background-color: ${(props) => props.theme.colors.brandWhite};
  grid-area: content-toolbar;
  position: sticky;
  top: 0;
  z-index: ${(props) => props.theme.layering.tooltip};
`;

interface IGroupManagementContentToolbarProps {
  children?: React.ReactNode;
}

function GroupManagementContentToolbar({
  children,
}: IGroupManagementContentToolbarProps) {
  const { headerPortalRef } = useContext(GlobalContext);

  return (
    <StyledContentToolbar ref={headerPortalRef}>
      {children}
      <ToolbarSnacksContainer />
    </StyledContentToolbar>
  );
}

export default GroupManagementContentToolbar;
